import React from 'react'
import './Toggle.css';
import { FaSun } from 'react-icons/fa';
import { FaMoon } from 'react-icons/fa';
import { themeContext } from '../../Context';
import { useContext } from 'react';
export default function Toggle() {
    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;
    const handleClick =()=>{
     theme.dispatch({type:'toggle'});
    }
  return (
    <div className="toggle"onClick ={handleClick}>
        <FaSun/>
        <FaMoon/>
        <button className='btn' 
        style={
          darkMode?  {left:'2px'}: {right:'2px'}
        }
        ></button>
    </div>
  )
}
